/**
 * jQuery Cookie plugin
 *
 * Copyright (c) 2010 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */
eval(function(p, a, c, k, e, r) {
    e = function(c) {
        return (c < a ? '' : e(parseInt(c / a))) + ((c = c % a) > 35 ? String.fromCharCode(c + 29) : c.toString(36))
    };
    if (!''.replace(/^/, String)) {
        while (c--) r[e(c)] = k[c] || e(c);
        k = [

            function(e) {
                return r[e]
            }
        ];
        e = function() {
            return '\\w+'
        };
        c = 1
    };
    while (c--)
        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
    return p
}('f.b=j(7,2,0){5(B.A>1&&h(2)!=="[z n]"){0=f.w({},0);5(2===d||2===v){0.3=-1}5(r 0.3===\'q\'){i c=0.3,t=0.3=l p();t.x(t.o()+c)}2=h(2);9(m.b=[a(7),\'=\',0.g?2:a(2),0.3?\'; 3=\'+0.3.u():\'\',0.8?\'; 8=\'+0.8:\'\',0.4?\'; 4=\'+0.4:\'\',0.k?\'; k\':\'\'].y(\'\'))}0=2||{};i 6,e=0.g?j(s){9 s}:C;9(6=l D(\'(?:^|; )\'+a(7)+\'=([^;]*)\').E(m.b))?e(6[1]):d};', 41, 41, 'options||value|expires|domain|if|result|key|path|return|encodeURIComponent|cookie|days|null|decode|jQuery|raw|String|var|function|secure|new|document|Object|getDate|Date|number|typeof|||toUTCString|undefined|extend|setDate|join|object|length|arguments|decodeURIComponent|RegExp|exec'.split('|'), 0, {}))

var currentCurrency = RC_storeCurrency;
RC_cookieName += '-rc';
jQuery(document).ready(function() {

    var rememberedCurrency = $.cookie(RC_cookieName);
    if (rememberedCurrency != "" && rememberedCurrency != null) {
        currentCurrency = rememberedCurrency;
    }

    // build the currency pick list
    var currPick = document.getElementById(RC_currencySwitcherClass);
    if (currPick != null) {
        var selectCurrency = document.createElement("select");
        for (var i = 0; i < RC_importantCurrencys.length; ++i) {
            var currency = RC_importantCurrencys[i];
            var selectCurrencyOption = document.createElement("option");
            selectCurrencyOption.innerHTML = currency;
            if (currency == currentCurrency) {
                selectCurrencyOption.setAttribute("selected", "selected");
            }
            selectCurrency.appendChild(selectCurrencyOption);
        }
        if (RC_importantCurrencys.length > 0) {
            var selectCurrencyOption = document.createElement("option");
            selectCurrencyOption.innerHTML = "----";
            selectCurrency.appendChild(selectCurrencyOption);
        }
        var arrCurrencies = getAndSortKeys(Currency.rates);
        for (var j = 0; j < arrCurrencies.length; ++j) {
            var currency = arrCurrencies[j];

            // skip currencies that are not in RC_showOnlyCurrencys
            if (RC_showOnlyCurrencys && RC_showOnlyCurrencys.indexOf && RC_showOnlyCurrencys.indexOf(currency)) {
                continue;
            }

            var found = false;
            for (var i = 0; i < RC_importantCurrencys.length; ++i) {
                if (currency == RC_importantCurrencys[i]) {
                    found = true;
                }
            }
            if (found) continue;
            var selectCurrencyOption = document.createElement("option");
            selectCurrencyOption.innerHTML = currency;
            if (currency == currentCurrency) {
                selectCurrencyOption.setAttribute("selected", "selected");
            }
            selectCurrency.appendChild(selectCurrencyOption);
        }
        currPick.innerHTML = '';
        currPick.appendChild(selectCurrency);
        jQuery(selectCurrency).change(function() {
            currentCurrency = selectCurrency.options[selectCurrency.selectedIndex].value;
            $.cookie(RC_cookieName, currentCurrency, {
                expires: 365,
                path: '/'
            });
            updateAllMoney();
        });
    }

    updateAllMoney();
});

function getAndSortKeys(assArray) {
    var retArray = [];
    for (var currency in Currency.rates) {
        retArray.push(currency);
    }
    return retArray.sort();
};

function updateAllMoney() {
    //format all money currently on the page
    jQuery("." + RC_moneyClass).each(function() {
        if ($(this).html().length > 0)
            updateMoneyNode(this, false);
    });
};

function resetMoneyNode(moneyNode) {
    updateMoneyNode(moneyNode, true);
};

function updateMoneyNode(moneyNode, clear) {
    var $moneyNode = jQuery(moneyNode);
    var origPrice = $moneyNode.data('origPrice');

    if (origPrice == null || origPrice == '' || clear) {
        origPrice = currency2float($moneyNode.html());
        $moneyNode.data('origPrice', origPrice);
    }

    $moneyNode.html(CurrencyInfo.getPrice(origPrice));
};


function currency2float(m) {
    var f = m.match(/[\d]+[\d,.]+/).toString();
    //Denmark, Krone us a decimal for thousands seperator
    var thousandsSeperator = (RC_storeCurrency == 'DKK') ? '.' : ',';
    var re = new RegExp(thousandsSeperator, 'g');
    return f.replace(re, '');
};


var CurrencyInfo = {
    symbol: {
        "AED": [68, 104],
        "ZAR": [82],
        "EEK": [107, 114],
        "HRK": [107, 110],
        "IDR": [82, 112],
        "TWD": [78, 84, 36],
        "CHF": [83, 70, 114, 46, 32],
        "JMD": [74, 36],
        "ISK": [107, 114],
        "HKD": [72, 75, 36],
        "PHP": [80, 104, 112],
        "NZD": [36],
        "LVL": [76, 115],
        "INR": [8360],
        "ARS": [36],
        "EUR": [8364],
        "XCD": [36],
        "THB": [3647],
        "SEK": [107, 114],
        "MXN": [36],
        "HUF": [70, 116],
        "CNY": [20803],
        "COP": [36],
        "TTD": [84, 84, 36],
        "LTL": [76, 116],
        "DKK": [107, 114],
        "CYP": [163],
        "ILS": [8362],
        "TRY": [89, 84, 76],
        "KRW": [8361],
        "SGD": [36],
        "MTL": [76, 109],
        "AUD": [36],
        "RON": [108, 101, 105],
        "MYR": [82, 77],
        "UYU": [36, 85],
        "BRL": [82, 36],
        "CAD": [36],
        "USD": [36],
        "PLN": [122, 322],
        "CLP": [36],
        "VEB": [66, 115],
        "BSD": [36],
        "SIT": [83, 73, 84],
        "SKK": [83, 107],
        "JPY": [165],
        "RUB": [1088, 1091, 1073],
        "CRC": [8353],
        "CZK": [75, 269],
        "SYP": [163],
        "NOK": [107, 114],
        "GBP": [163]
    },
    getSymbol: function(rate) {
        return (RC_showCurrencyLabel && CurrencyInfo.symbol[rate]) ? '&#' + CurrencyInfo.symbol[rate].join(';&#') + ';' : '';
    },
    formatPrice: function(amount, currency) {
        var i = parseFloat(amount);
        if (isNaN(i)) {
            i = 0.00;
        }
        var minus = '';
        if (i < 0) {
            minus = '-';
        }
        i = Math.abs(i);
        i = parseInt((i + .005) * 100);
        i = i / 100;
        s = new String(i);

        var thousandsSeperator = ',';
        var decimalSeperator = '.';
        if (currency == 'DKK') {
            thousandsSeperator = '.';
            decimalSeperator = ',';
        }

        if (s.indexOf(decimalSeperator) < 0) {
            s += decimalSeperator + '00';
        }
        if (s.indexOf(decimalSeperator) == (s.length - 2)) {
            s += '0';
        }
        s = minus + s;
        var addThousandsSeperator = new RegExp('(-?[0-9]+)([0-9]{3})');
        while (addThousandsSeperator.test(s)) {
            s = s.replace(addThousandsSeperator, '$1' + thousandsSeperator + '$2');
        }
      if (RC_showCurrencyLabel) {
        s += ' ' + currency;
      }
        return s;
    },
    getPrice: function(price) {
      console.log(CurrencyInfo.getSymbol(currentCurrency) + CurrencyInfo.formatPrice(Currency.convert((parseFloat(price)), RC_storeCurrency, currentCurrency), currentCurrency));
        return CurrencyInfo.getSymbol(currentCurrency) + CurrencyInfo.formatPrice(Currency.convert((parseFloat(price)), RC_storeCurrency, currentCurrency), currentCurrency);
    }
};